import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;
const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/notificacaoSmtpController');

export interface NotificacaoSmtpConfigDTO {
  id?: number;
  ativo?: boolean;
  smtpHost?: string;
  smtpPort?: number;
  smtpUsername?: string;
  smtpPassword?: string;
  smtpAuth?: boolean;
  smtpStarttls?: boolean;
  emailRemetente?: string;
  nomeRemetente?: string;
  emailsDestino?: string;
  gestaoPromotora?: boolean;
}

export interface NotificacaoEmailTemplateDTO {
  id?: number;
  ativo?: boolean;
  modulo?: string;
  nome?: string;
  enviarTodosStatus?: boolean;
  statusGestao?: string;
  statusGestaoDescricao?: string;
  assunto?: string;
  corpoHtml?: string;
}

export interface StatusGestaoPromotoraOption {
  value: string;
  label: string;
}

export default class NotificacaoSmtpService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async buscarConfiguracao() {
    return await this.axios.get('/buscarConfiguracao');
  }

  async salvarConfiguracao(dto: NotificacaoSmtpConfigDTO) {
    return await this.axios.post('/salvarConfiguracao', dto);
  }

  async testarConfiguracao(dto: NotificacaoSmtpConfigDTO) {
    return await this.axios.post('/testarConfiguracao', dto);
  }

  async listarTemplatesGestaoPromotora() {
    return await this.axios.get('/listarTemplatesGestaoPromotora');
  }

  async salvarTemplate(dto: NotificacaoEmailTemplateDTO) {
    return await this.axios.post('/salvarTemplate', dto);
  }

  async excluirTemplate(id: number) {
    return await this.axios.delete(`/excluirTemplate?id=${id}`);
  }

  async preVisualizarTemplate(dto: NotificacaoEmailTemplateDTO) {
    return await this.axios.post('/preVisualizarTemplate', dto);
  }

  async listarStatusGestaoPromotora() {
    return await this.axios.get('/listarStatusGestaoPromotora');
  }
}
